import { useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import FeaturesGrid from "../components/Template/Features";
import LicenseSelector from "../components/Template/LicenseSelector";
import ServiceSelector from "../components/Template/ServiceSelector";
import "../index.css";
import TechnologyList from "../components/Template/Technology";
import { useGetTemplateById } from "../functions/templatesHook";
import ImageGallery from "../components/Template/ImageCase";
import TemplateCTA from "../components/Template/TemplateCTA";
import HelpButton from "../components/Template/Help";
import ProductDetails from "../components/Template/ProductDetails";
import IncludedPages from "../components/Template/PagesGrid";
import {SkeletonTemplate} from '../components/Template/TemplateDetailSkeleton'

export default function TemplateDetail() {
  const { templateId } = useParams<{ templateId: string }>(); // Obtener ID de la URL
  const { template, isLoading, isError } = useGetTemplateById(templateId!);

  const templateData = Array.isArray(template) ? template[0] : template;



  
  // Estado para la imagen activa
  const [activeImage, setActiveImage] = useState<string | undefined>(templateData?.previewImages?.[0]);
  const [showHelp, setShowHelp] = useState(false);
  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const [selectedLicense, setSelectedLicense] = useState<string | null>(null);


  // Si está cargando, mostramos un mensaje de carga
  if (isLoading) {
    return <SkeletonTemplate />;
  }

  // Si hay un error, mostramos el mensaje de error
  if (isError || !template) {
    return <div className="text-center text-xl text-gray-600">Template no encontrado</div>;
  }

  // Si el template viene en un array, tomamos el primero

  // Función para cambiar la imagen activa
  const handleImageClick = (image: string) => {
    setActiveImage(image);
  };

  // Abrir la demo en una nueva pestaña
  const openDemoPopup = () => {
    window.open(template?.demoUrl, '_blank', 'width=1000,height=1000');
  };
  

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      {/* Botón flotante de ayuda */}
      <HelpButton showHelp={showHelp} setShowHelp={setShowHelp} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        <ImageGallery title={templateData.title} previewImages={templateData.imageUrls} onImageClick={handleImageClick} />

        {/* Contenido desplazable */}
        <div className="space-y-12 lg:h-[calc(100vh-4rem)] scrollbar-hidden lg:overflow-y-auto lg:pb-16">
          {/* Sección CTA */}
          <TemplateCTA
            price={templateData.price}
            originalPrice={templateData.originalPrice}
            onPreviewClick={openDemoPopup}
            onAddToCart={() => {}}
          />

          {/* Selectores de Licencia y Servicios */}
          <LicenseSelector selectedLicense={selectedLicense ?? undefined} onSelect={setSelectedLicense} />
          <ServiceSelector selectedServices={selectedServices} onSelect={setSelectedServices} />

          {/* Detalles del producto */}
          <ProductDetails title={templateData.title} description={templateData.description} />

          {/* Grid de características y páginas incluidas */}
            <IncludedPages pages={templateData.includedPages} />

          <FeaturesGrid features={templateData.keyFeatures} />

          {/* Tecnologías utilizadas */}
          <TechnologyList technologies={templateData.technologyUsed} />

          {/* Badge de seguridad */}
          <div className="bg-navy-50 p-6 rounded-2xl flex items-center justify-center gap-3">
            <ShieldCheck className="w-6 h-6 text-navy-900" />
            <span className="text-sm text-navy-700">SSL Secured Transaction · 30-Day Money Back Guarantee</span>
          </div>
        </div>
      </div>
    </div>
  );
}
